module.exports = __webpack_public_path__ + "94ee8c3f.png";